import { MutationTree } from "vuex";
import { IMediaPlansStateInterface } from "./state";
import {
  IMediaplanItem,
  IOptionMimicry,
  IOptionsMimicry,
} from "src/modules/mediaplans/models/mediaplans";
import { IEmoji } from "src/modules/mediaplans/models/emoji";

const mutation: MutationTree<IMediaPlansStateInterface> = {
  setMediaplans(state, payload: IMediaplanItem[]) {
    state.mediaplans = payload;
  },
  setOptionsMimicry(
    state,
    payload: { type: keyof IOptionsMimicry; options: IOptionMimicry[] },
  ) {
    state.optionsMimicry[payload.type] = payload.options;
  },
  setEmojis(state, emojis: IEmoji[]) {
    state.emojis = emojis;
  },
};

export default mutation;
